
import { defineComponent, ref, onMounted } from "vue";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import router from "./router";

export default defineComponent({
  name: "App",

  setup() {
    const auth = ref(getAuth());
    const isLoggedIn = ref(false);

    function handleSignOut() {
      console.log("Usuário deslogado");

      signOut(auth.value).then(() => {
        router.push("/");
      });
    }

    onMounted(() => {
      onAuthStateChanged(auth.value, (user) => {
        if (user) {
          isLoggedIn.value = true;
        } else {
          isLoggedIn.value = false;
        }
      });
    });

    return {
      handleSignOut,
      isLoggedIn,
    };
  },
});
